import { TypesenseProduct } from '../../../../typesense/types'
import { ProductType } from '../../ProductCard'

export interface LocationState {
  category: string
  subCategory?: string
  isPriceNegotiable: boolean
  productTab: string
  productType: string
}

export async function getProductDetails(
  product: TypesenseProduct | undefined,
  state: LocationState | undefined,
) {
  let category = ''
  let subCategory = ''
  let isPriceNegotiable = false

  if (state?.productType === ProductType.Past) {
    category = state?.category
    isPriceNegotiable = state?.isPriceNegotiable
  } else if (state?.productType === ProductType.All) {
    category = state?.category
    subCategory = state?.subCategory ?? ''
    isPriceNegotiable = state?.isPriceNegotiable
  } else {
    const p = product
    category = p?.l1_category ?? ''
    subCategory = p?.l2_category ?? ''
    isPriceNegotiable = p?.price_negotiable ?? false
  }

  return { category, subCategory, isPriceNegotiable }
}
